import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/**
 * Broker
 */

function getBrokerRequest(brokerId) {
  return {
    type: ACTION_TYPES.GET_BROKER,
    payload: {
      id: brokerId,
    },
  };
}

function getBrokerSuccess(broker) {
  return {
    type: ACTION_TYPES.GET_BROKER_SUCCESS,
    payload: broker,
  };
}

function getBrokerFailure(error) {
  return {
    type: ACTION_TYPES.GET_BROKER_FAILURE,
    error,
  };
}

export function getBroker(brokerId) {
  return (dispatch) => {
    dispatch(getBrokerRequest(brokerId));
    return new Promise((resolve, reject) => {
      api
        .getBroker(brokerId)
        .then((broker) => {
          dispatch(getBrokerSuccess(broker));
          resolve(broker);
        })
        .catch((error) => {
          dispatch(getBrokerFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Brokerage
 */

function getBrokerageRequest(brokerageSlug) {
  return {
    type: ACTION_TYPES.GET_BROKERAGE,
    payload: brokerageSlug,
  };
}

function getBrokerageSuccess(brokerage) {
  return {
    type: ACTION_TYPES.GET_BROKERAGE_SUCCESS,
    payload: brokerage,
  };
}

function getBrokerageFailure(error) {
  return {
    type: ACTION_TYPES.GET_BROKERAGE_FAILURE,
    error,
  };
}

export function getBrokerage(brokerageSlug) {
  return (dispatch) => {
    dispatch(getBrokerageRequest(brokerageSlug));
    return new Promise((resolve, reject) => {
      api
        .getBrokerage(brokerageSlug)
        .then((brokerage) => {
          dispatch(getBrokerageSuccess(brokerage));
          resolve(brokerage);
        })
        .catch((error) => {
          dispatch(getBrokerageFailure(error));
          reject(error);
        });
    });
  };
}
